import Api from "@/api";
// import Cookies from 'js-cookie';
// import md5 from 'js-md5'
import {
    findTarget,
    getObjVal,
    _isValue,
} from 'tools';
import menuList from '@/router/menu';
const user = {
    state: {
        isProPriceShow: true,
        wYBroker: false, //是否是签约人员
        userId: null,
        userName: "",
        userLogo: "",
        loginStatus: false,
        showLogin: false,
        header: "",
        goPageAfterLogin: "",
        userUuid: "",
        userTier: null,
        menuTitle: '',
        toPath: '',
        quasiA: false,
        isNoAgentOrC: false, //是否非代理人/C
        agencyName: '',//团险商户
        name: '', //团险名字
        isTXSystem: false,//团险系统
        appId: '',
        openId: '',
    },

    mutations: {
        SET_USER_INFO: (state, data) => {
            console.log("SET_USER_INFO", data)
            if (data) {
                const userTier = getObjVal(data, 'userTier');
                state.wYBroker = data.wYBroker || data.wybroker;
                state.isProPriceShow = data.isProPriceShow;
                state.userId = data.id
                state.userName = data.name;
                state.userUuid = data.uuid;
                state.userLogo = data.logoImg;
                state.userTier = userTier;
                state.loginStatus = true;

                // 是否是准A
                if (_isValue(userTier)) {
                    state.quasiA = [2, 3, 6].includes(+userTier);
                    state.isNoAgentOrC = [0, 7].includes(+userTier);
                };

                state.agencyName = data.agencyName || '';
                state.name = data.name || '';
                state.appId = data.appId || '';
                state.openId = data.openId || '';

                if (data.appId && data.openId) {
                    state.isTXSystem = true;
                } else {
                    state.isTXSystem = false;
                }

                return false;
                if ([2, 3, 6].includes(Number(data.userTier))) {
                    state.quasiA = true
                };
            } else {
                state.isProPriceShow = false;
                state.wYBroker = false;
                state.userName = "";
                state.userUuid = "";
                state.loginStatus = false;
                state.quasiA = false;
                state.name = '';
                state.appId = '';
                state.openId = '';
            }
        },
        SET_LOGIN_MODAL: (state, flag) => {
            state.showLogin = !!flag;
        },
        //设置菜单标题
        SET_MENU_TITLE: (state, title) => {
            state.menuTitle = title;
        },
        //设置路由topath与菜单标题
        SET_TO_PATH: (state, path) => {
            state.toPath = path;
            const curData = findTarget(menuList, _ => _.path == path, 'child') || {};
            state.menuTitle = curData.title;
        },
        SET_HEADER: (state, path) => {
            if (path.indexOf("order") > -1) {
                state.header = "orderList";
            } else if (path.indexOf("unfinishList") > -1) {
                state.header = "unfinishList";
            } else if (path.indexOf("information") > -1) {
                state.header = "information";
            } else {
                state.header = "productList";
            }
        },
        SET_GO_PAGE: (state, value) => {
            state.goPageAfterLogin = value;
        }
    },

    actions: {
        // 设置setCookies
        // setcookies({ commit, state }, params) {
        //     return new Promise((resolve, reject) => {
        //         Api.setcookies(params)
        //             .then(response => {
        //                 resolve(true);
        //             })
        //             .catch(error => {
        //                 reject(error);
        //             });
        //     });
        // },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                Api.getUserInfo()
                    .then(response => {
                        const data = response.data;
                        commit("SET_USER_INFO", data);
                        commit("SET_LOGIN_MODAL", false);
                        resolve(response);
                    })
                    .catch(error => {
                        commit("SET_USER_INFO");
                        reject(error);
                    });
            });
        },

        // 登录
        Login({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                console.log("登录");
                Api.login(params)
                    .then(response => {
                        commit("SET_USER_INFO", response.data);
                        commit("SET_LOGIN_MODAL", false);
                        resolve(response);
                    })
                    .catch(error => {
                        commit("SET_USER_INFO");
                        reject(error);
                    });
            });
        },

        // 前端 登出
        Logout({ commit }) {
            return new Promise((resolve, reject) => {
                console.log("退出登录");
                Api.logout()
                    .then(rep => {
                        commit("SET_USER_INFO");
                        resolve(rep);
                    })
                    .catch(e => {
                        commit("SET_USER_INFO");
                        reject(e);
                    });
            });
        },
        OauthLogin({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                Api.oauthLogin(params)
                    .then(response => {
                        commit("SET_USER_INFO", response.data);
                        commit("SET_LOGIN_MODAL", false);
                        resolve(response);
                    })
                    .catch(error => {
                        commit("SET_USER_INFO");
                        reject(error);
                    });
            });
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js